export async function sendContactRequest(
  endpoint: string,
  data: FormData,
  fetcher: typeof fetch = fetch
): Promise<void> {
  const response = await fetcher(endpoint, {
    method: 'POST',
    body: data,
    headers: { Accept: 'application/json' }
  });
  if (!response.ok) throw new Error('contact_failed');
}
